/**
 * 해당 상수는 주문 상태 되돌리기(구매확정)에서 유효성 체크를 위해 사용되며 추후 에러 처리에 대한 정책 수립 후 개선 필요
 *
 * [참조]
 * https://devadminapiv2.dev-amondz.com/api-docs/#/order-confirms/OrderConfirmsController_cancelableOrderConfirm
 * GET /api/order-confirms/{orderItemId}/cancelable
 */

const ORDER_ERROR_CODE = {
  ORDER_101: 'ORDER101',
  ORDER_102: 'ORDER102',
  ORDER_103: 'ORDER103',
  ORDER_104: 'ORDER104',
  ORDER_105: 'ORDER105',
  ORDER_106: 'ORDER106',
  ORDER_107: 'ORDER107',
  ORDER_108: 'ORDER108',
  ORDER_109: 'ORDER109',
};

const ORDER_ERROR_MESSAGE = {
  [ORDER_ERROR_CODE.ORDER_101]:
    '정산이 완료되어 주문 상태를 변경할 수 없습니다. 이전 상태가 배송완료상태이며 현재 구매확정 상태에서만 취소가 가능합니다.',
  [ORDER_ERROR_CODE.ORDER_102]: 'orderItem에 order 정보가 없습니다. join이 누락되지 않았는지 체크해보세요.',
  [ORDER_ERROR_CODE.ORDER_103]: '구매확정 포인트를 회수 할 수 없습니다. 상태 변경은 담당자에게 문의 바랍니다.',
  [ORDER_ERROR_CODE.ORDER_104]: '고객이 보유한 포인트가 부족하여 주문 상태를 변경할 수 없습니다.',
  [ORDER_ERROR_CODE.ORDER_105]: 'orderItemId는 필수값입니다.',
  [ORDER_ERROR_CODE.ORDER_106]: '유효하지 않은 orderItemId 형식입니다. string으로 전송되어야 합니다.',
  [ORDER_ERROR_CODE.ORDER_107]: '정산이 완료되어 주문 상태를 변경할 수 없습니다.',
  [ORDER_ERROR_CODE.ORDER_108]: '후기작성 포인트를 회수 할 수 없습니다. 상태 변경은 담당자에게 문의 바랍니다.',
  [ORDER_ERROR_CODE.ORDER_109]: "직전 주문 상태가 '배송완료'인 경우만 상태 변경 가능합니다.",
};

export default ORDER_ERROR_MESSAGE;
